/** In-memory hand-off of the last completion result to the /result route (one tab, one attempt). */
export interface LastResult {
  hazardProfileId: string;
  passed: boolean;
  score: number;
  weakChapterIds: string[];
}

let last: LastResult | null = null;

export function setLastResult(r: LastResult): void {
  last = r;
}

export function getLastResult(): LastResult | null {
  return last;
}
